import { auditLabel, projectDate } from '@entities/ksp/format';
import type { AuditEvent, KspWorkspace } from '@entities/ksp/types';
import { Button } from '@shared/ui/Button';
import { Card, Small, Stack } from '../styles';
import { sourceText } from '../types';
import { PagedTable } from '../components/CollectionTable';

export interface HistoryTabProps {
  workspace: KspWorkspace;
  projectId: string;
  timezone: string;
  auditDetails: Record<string, AuditEvent>;
  auditPending: string;
  fetchingAuditPage: { isFetching: boolean };
  loadAuditDetails: (event: AuditEvent) => Promise<void>;
}

export function HistoryTab({
  workspace: d,
  projectId,
  timezone,
  auditDetails,
  auditPending,
  fetchingAuditPage,
  loadAuditDetails,
}: HistoryTabProps) {
  return (
    <Card>
      <h3>История версий, решений и источников</h3>
      <PagedTable
        rows={d.audit_events.map(
          (event) => auditDetails[`${projectId}:${event.id}`] ?? event,
        )}
        collection="audit_events"
        columns={[
          { name: 'Дата', value: (event) => projectDate(event.at, timezone) },
          { name: 'Автор', value: (event) => event.actor ?? 'система' },
          {
            name: 'Действие',
            value: (event) => <span title={event.action}>{auditLabel(event.action)}</span>,
          },
          {
            name: 'Ревизия данных',
            value: (event) => (
              <span title={event.object_id ? `Объект ${event.object_id}` : undefined}>
                {event.version ?? '—'}
              </span>
            ),
          },
          {
            name: 'Основание',
            value: (event) => (
              <>
                {event.reason}
                {event.source_refs?.map((source, i) => (
                  <Small key={i}>{sourceText(source)}</Small>
                ))}
                {event.payload_deferred && (
                  <Stack>
                    <Small>Основание и источники доступны в полной записи.</Small>
                    <Button
                      $variant="ghost"
                      $size="sm"
                      disabled={fetchingAuditPage.isFetching}
                      onClick={() => loadAuditDetails(event)}
                    >
                      {auditPending === `${projectId}:${event.id}`
                        ? 'Загрузка…'
                        : 'Загрузить подробности'}
                    </Button>
                  </Stack>
                )}
              </>
            ),
          },
        ]}
      />
    </Card>
  );
}
